import React from 'react';
import { Grid, Button, Alert } from '@mui/material';
import { useModalContext } from './ModalContext';
import ErrorBoundary from 'components/Error/ErrorBoundary';
import {
  useSeedTalentDefaults,
  SeedTalentDetailsCard,
  SeedTalentApiCard,
  WebhookSourceCard,
  CostCenterCard,
  GroupMappingCard,
  CostCenterBlocklistCard,
  SeedTalentNotificationsCard
} from './seedTalentFormShared';

export const SeedTalentIntegrationForm = () => {
  const { onSubmitIntegration, isUpdate, formState } = useModalContext();
  useSeedTalentDefaults();

  const errors = formState.seedTalentErrors || {};
  const errorCount = Object.keys(errors).length;

  return (
    <ErrorBoundary context="Seed Talent integration form">
      <form onSubmit={onSubmitIntegration}>
        <Grid container direction="column" spacing={3} wrap="nowrap">
          {errorCount > 0 && (
            <Grid item>
              <Alert severity="error">
                {errorCount === 1
                  ? 'Fix the highlighted field before saving:'
                  : `Fix the ${errorCount} highlighted fields before saving:`}
                <ul>
                  {Object.entries(errors).map(([field, message]) => (
                    <li key={field}>{message}</li>
                  ))}
                </ul>
              </Alert>
            </Grid>
          )}
          <Grid item>
            <SeedTalentDetailsCard errors={errors} />
          </Grid>
          <Grid item>
            <SeedTalentApiCard errors={errors} />
          </Grid>
          <Grid item>
            <WebhookSourceCard errors={errors} />
          </Grid>
          <Grid item>
            <CostCenterCard errors={errors} />
          </Grid>
          <Grid item>
            <GroupMappingCard errors={errors} />
          </Grid>
          <Grid item>
            <CostCenterBlocklistCard />
          </Grid>
          <Grid item>
            <SeedTalentNotificationsCard />
          </Grid>
          <Grid item>
            <Button color="primary" type="submit" variant="contained">
              {isUpdate ? 'Update Integration' : 'Save Integration'}
            </Button>
          </Grid>
        </Grid>
      </form>
    </ErrorBoundary>
  );
};

export default SeedTalentIntegrationForm;
